// Hooks
export { useSocialLogin } from "./hooks/useSocialLogin";
export { useLogout } from "./hooks/useLogout";

// Components
export { LogoutButton } from "./components/LogoutButton";
export {
  AUTH_ICON_BUTTON_CLASS,
  AUTH_PRIMARY_BUTTON_CLASS,
  AUTH_SECONDARY_BUTTON_CLASS,
  AuthResponsivePage,
} from "./components/AuthResponsivePage";
export {
  AUTH_WEB_ASIDE_CARD_CLASS,
  AUTH_WEB_CONTENT_SURFACE_CLASS,
  AuthOnboardingAsideCard,
  AuthOnboardingContentSurface,
  AuthOnboardingShell,
} from "./components/AuthOnboardingShell";

// Config
export {
  ADD_ACCOUNT_SOURCE_IDS,
  CONNECT_ACCOUNT_SOURCE_IDS,
  CREATOR_SOURCE_CONFIG,
  ESTIMATE_EARNINGS_PRIMARY_SOURCE_ID,
  ESTIMATE_EARNINGS_SECONDARY_SOURCE_IDS,
  getCreatorSourceConfig,
  isOnboardingCreatorSource,
} from "./config/creatorSources";
export type { OnboardingCreatorSource } from "./config/creatorSources";

// Services
export { 
  fetchSocialRedirect, 
  useSocialRedirectMutation,
  fetchLogout,
  useLogoutMutation 
} from "./services/socialAuthClient";
